import React, { Fragment } from "react";
import { formTypes } from "../../formTypes";

const Buttons = (props) => {
  const {type, fromContact, onClose} = props
  const types = formTypes[type]
  const { btns } = types

  const handleClick = (e, customEvent) => {
    e.preventDefault()
    props[customEvent]()
  }

  return (
    <div className={`btn-content ${types.isRow ? "rows" : ""}`}>
      { btns.map((btn) => {

        if (btn.createAccount && !fromContact) return null

        if (btn.link) {
          return (
            <a
              rel="noreferrer"
              target="_blank"
              key={btn.txt}
              onClick={(e) => {
                if (window.location.pathname.includes(btn.link)) {
                  e.preventDefault()
                  onClose()
                }
              }}
              href={btn.link}
              className={btn.customClass}>
                {btn.txt}
              </a>
          )
        }

        return (
          <Fragment key={btn.txt}>
            <button
              onClick={(e) => handleClick(e, btn.customEvent)}
              className={`button-custom ${btn.customClass}`}>
                {btn.txt}
              </button>
            {btn.orLine && <p className="or-line">or</p>}
          </Fragment>
        )
      })}
    </div>
  )
}

export default Buttons